module.exports = __webpack_public_path__ + "static/media/Intro_socios_promotores.2594bd72.mp4";